module.exports = "<!---start preloader-->\n<div  id=\"survey_link_preloader\">\n    <div id=\"loader\"></div>\n</div>\n<!--end preloader-->"